<template>
  <div class="scrollable">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "ReportsScreen",
}
</script>

<style>

</style>